'use client';

import clsx from 'clsx';
import { FC, PropsWithChildren, useState } from 'react';
import { VideoModal } from 'src/general/components/VideoModal/VideoModal';

type Props = {
  className?: string;
  videoUrl: string;
};

export const VideoModalTrigger: FC<PropsWithChildren<Props>> = ({ className, videoUrl, children }) => {
  const [videoOpen, setVideoOpen] = useState<boolean>(false);

  return (
    <>
      <button
        onClick={() => setVideoOpen(true)}
        className={clsx(
          'absolute top-0 left-0 z-1 m-0 h-full w-full cursor-pointer appearance-none border-0 bg-transparent p-0',
          className,
        )}
      >
        <span className="sr-only">Play video</span>
        {children}
      </button>
      <VideoModal isOpen={videoOpen} onClose={() => setVideoOpen(false)} videoUrl={videoUrl} />
    </>
  );
};
